import type { ConnectProto } from "@racoon/api";

/**
 * The jobs the table's checked keys name, looked up among the jobs checked before and
 * the loaded ones. A re-sort reloads the list from its first page, so a job checked on a
 * later page stays checked (and acted on) though it is not loaded any more.
 */
export const pickCheckedJobs = (
  keys: readonly React.Key[],
  checked: readonly ConnectProto.Job[],
  loaded: readonly ConnectProto.Job[],
): ConnectProto.Job[] => {
  const known = new Map([...checked, ...loaded].map((job) => [String(job.id), job]));
  return keys.flatMap((key) => known.get(String(key)) ?? []);
};

/** Each checked job as last loaded, so an action sees an edit made since it was ticked. */
export const freshCheckedJobs = (
  checked: readonly ConnectProto.Job[],
  loaded: readonly ConnectProto.Job[],
): ConnectProto.Job[] => {
  if (checked.length === 0) return [];
  const byId = new Map(loaded.map((job) => [String(job.id), job]));
  return checked.map((job) => byId.get(String(job.id)) ?? job);
};
